import { render, staticRenderFns } from "./GeneralEffectsButtons.vue?vue&type=template&id=99575626&"
import script from "./GeneralEffectsButtons.vue?vue&type=script&lang=js&"
export * from "./GeneralEffectsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports